import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import nque from './assets/nque.png'
import perm from './assets/perm.png'
import plndrm from './assets/plndrm.png'
import add from './assets/add.jpg'
import countSq from './assets/countSq.jpg'
import lps from './assets/lps.svg'
import cc from './assets/cc.jpg'
import buy from './assets/buy.jpg'
import subM from './assets/subM.png'
import maxR from './assets/maxR.png'
import rootl from './assets/rootl.jpg'
import lca from './assets/lca.png'
import lot from './assets/lot.png'
import stkq from './assets/stkq.png'
import nth from './assets/nth.jpg'
const Ind = () => {
    return (
        <div>
          <h1 style={{textAlign:'center'}}>Accolite interview question</h1>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={countSq}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Count Squares</p>
      <NavLink to='/category/Accolite Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={lps} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Longest Prefix Suffix</p>
      <NavLink to='/category/Accolite Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={nque} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>N-Queen Problem</p>
        <NavLink to='/category/Accolite Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={cc} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Coin Change</p>
      <NavLink to='/category/Accolite Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={perm} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Permutations of a given string</p>
      <NavLink to='/category/Accolite Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={buy} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Stock buy and sell</p>
      <NavLink to='/category/Accolite Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={lps} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Longest Palindrome in a String</p>
        <NavLink to='/category/Accolite Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={add} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Sum of two numbers represented as arrays</p>
      <NavLink to='/category/Accolite Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={subM} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Max sum submatrix</p>
      <NavLink to='/category/Accolite Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={maxR} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Maximum sum Rectangle</p>
      <NavLink to='/category/Accolite Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={rootl} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Root to leaf path sum</p>
        <NavLink to='/category/Accolite Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={lca} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Lowest Common Ancestor in a Binary Tree</p>
      <NavLink to='/category/Accolite Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={lot} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Level order traversal in spiral form</p>
      <NavLink to='/category/Accolite Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={stkq} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Implement Stack using Queues</p>
      <NavLink to='/category/Accolite Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={nth} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>n’th node from end of linked list</p>
        <NavLink to='/category/Accolite Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    </div>
        </div>
    )
}

export default Ind
